import { BASE_URL } from '../constants';

const getSingleTournament = async (tourn_id = 'default') => {
  try {
    const response = await fetch(`${BASE_URL}/api/v2/tournaments/${tourn_id}`);

    const json = await response.json();

    if (json.error) {
      throw new Error(json.error.errorMessage);
    }

    return json.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export default getSingleTournament;
